/* ===== AROMAZUR v30 — description longue repliee en accordeon =====
   Chaque <h3> de la description Shopify devient un volet depliable.
   Le texte d'accroche situe avant le premier titre reste visible.
   On utilise <details>/<summary> : le contenu reste dans le DOM,
   donc Google l'indexe normalement, meme replie.                      */
(function(){

  function transforme(root){
    if(!root || root.getAttribute('data-acc')==='1') return;

    /* on ne prend qu'un seul niveau de titre : celui du premier rencontre */
    var premier = root.querySelector('h2,h3,h4');
    if(!premier) return;
    var TAG = premier.tagName;
    var nb  = root.querySelectorAll(TAG).length;
    if(nb < 2) return;                       /* une seule section : inutile */

    var noeuds = [].slice.call(root.childNodes);
    var intro  = document.createElement('div'); intro.className='az-acc-intro';
    var liste  = document.createElement('div'); liste.className='az-acc-liste';
    var corps  = null, premierVolet = null;

    noeuds.forEach(function(n){
      if(n.nodeType===1 && n.tagName===TAG){
        var d=document.createElement('details'); d.className='az-acc';
        var s=document.createElement('summary'); s.className='az-acc-t';
        s.innerHTML='<span class="az-acc-lab">'+n.innerHTML+'</span><span class="az-acc-i" aria-hidden="true"></span>';
        corps=document.createElement('div'); corps.className='az-acc-b';
        d.appendChild(s); d.appendChild(corps);
        liste.appendChild(d);
        if(!premierVolet) premierVolet=d;
      } else if(corps){
        corps.appendChild(n);                /* appendChild deplace le noeud */
      } else {
        intro.appendChild(n);
      }
    });

    root.textContent='';
    if(intro.childNodes.length) root.appendChild(intro);
    root.appendChild(liste);
    if(premierVolet) premierVolet.open=true; /* le premier volet est ouvert */
    root.setAttribute('data-acc','1');
    root.classList.add('az-acc-on');
  }

  /* le tableau des metachamps Shopify rejoint l'accordeon, au lieu de flotter dessous */
  function absorbeSpecs(){
    var desc=document.querySelector('.pp-below .pp-desc.az-acc-on');
    var spec=document.querySelector('.pp-below .pp-specs');
    if(!desc||!spec) return;
    var liste=desc.querySelector('.az-acc-liste'); if(!liste) return;
    var t=spec.querySelector('h3');
    var d=document.createElement('details'); d.className='az-acc';
    var s=document.createElement('summary'); s.className='az-acc-t';
    s.innerHTML='<span class="az-acc-lab">'+(t?t.innerHTML:'Caractéristiques techniques')+'</span><span class="az-acc-i" aria-hidden="true"></span>';
    var c=document.createElement('div'); c.className='az-acc-b';
    if(t) t.parentNode.removeChild(t);
    while(spec.firstChild) c.appendChild(spec.firstChild);
    d.appendChild(s); d.appendChild(c);
    liste.appendChild(d);
    spec.parentNode.removeChild(spec);
  }

  function boot(){
    /* fiches produit uniquement : les pages editoriales se lisent d'un trait */
    document.querySelectorAll('.pp-below .pp-desc').forEach(transforme);
    absorbeSpecs();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();
